export class ErrorMessages {
  public error = 'error.error';
  public errorContactAdmin = 'error.error_contact_admin';
  public errorMiddleware = 'error.error_middleware';
  public errorSecurity = 'error.error_security';
  public errorService = 'error.error_service';
  public CKR_ATTRIBUTE_READ_ONLY = 'error.scws_error.CKR_ATTRIBUTE_READ_ONLY';
  public CKR_ATTRIBUTE_SENSITIVE = 'error.scws_error.CKR_ATTRIBUTE_SENSITIVE';
  public CKR_ATTRIBUTE_TYPE_INVALID = 'error.scws_error.CKR_ATTRIBUTE_TYPE_INVALID';
  public CKR_ATTRIBUTE_VALUE_INVALID = 'error.scws_error.CKR_ATTRIBUTE_VALUE_INVALID';
  public CKR_DATA_INVALID = 'error.scws_error.CKR_DATA_INVALID';
  public CKR_DATA_LEN_RANGE = 'error.scws_error.CKR_DATA_LEN_RANGE';
  public CKR_DEVICE_ERROR = 'error.scws_error.CKR_DEVICE_ERROR';
  public CKR_DEVICE_MEMORY = 'error.scws_error.CKR_DEVICE_MEMORY';
  public CKR_DEVICE_REMOVED = 'error.scws_error.CKR_DEVICE_REMOVED';
  public CKR_ENCRYPTED_DATA_INVALID = 'error.scws_error.CKR_ENCRYPTED_DATA_INVALID';
  public CKR_ENCRYPTED_DATA_LEN_RANGE = 'error.scws_error.CKR_ENCRYPTED_DATA_LEN_RANGE';
  public CKR_FUNCTION_CANCELED = 'error.scws_error.CKR_FUNCTION_CANCELED';
  public CKR_FUNCTION_FAILED = 'error.scws_error.CKR_FUNCTION_FAILED';
  public CKR_FUNCTION_NOT_SUPPORTED = 'error.scws_error.CKR_FUNCTION_NOT_SUPPORTED';
  public CKR_GENERAL_ERROR = 'error.scws_error.CKR_GENERAL_ERROR';
  public CKR_HOST_MEMORY = 'error.scws_error.CKR_HOST_MEMORY';
  public CKR_INFORMATION_SENSITIVE = 'error.scws_error.CKR_INFORMATION_SENSITIVE';
  public CKR_KEY_FUNCTION_NOT_PERMITTED = 'error.scws_error.CKR_KEY_FUNCTION_NOT_PERMITTED';
  public CKR_KEY_SIZE_RANGE = 'error.scws_error.CKR_KEY_SIZE_RANGE';
  public CKR_KEY_TYPE_INCONSISTENT = 'error.scws_error.CKR_KEY_TYPE_INCONSISTENT';
  public CKR_KEY_UNEXTRACTABLE = 'error.scws_error.CKR_KEY_UNEXTRACTABLE';
  public CKR_MECHANISM_INVALID = 'error.scws_error.CKR_MECHANISM_INVALID';
  public CKR_MECHANISM_PARAM_INVALID = 'error.scws_error.CKR_MECHANISM_PARAM_INVALID';
  public CKR_PIN_EXPIRED = 'error.scws_error.CKR_PIN_EXPIRED';
  public CKR_PIN_INCORRECT = 'error.scws_error.CKR_PIN_INCORRECT';
  public CKR_PIN_INVALID = 'error.scws_error.CKR_PIN_INVALID';
  public CKR_PIN_LEN_RANGE = 'error.scws_error.CKR_PIN_LEN_RANGE';
  public CKR_PIN_LOCKED = 'error.scws_error.CKR_PIN_LOCKED';
  public CKR_SIGNATURE_INVALID = 'error.scws_error.CKR_SIGNATURE_INVALID';
  public CKR_SIGNATURE_LEN_RANGE = 'error.scws_error.CKR_SIGNATURE_LEN_RANGE';
  public CKR_TOKEN_NOT_PRESENT = 'error.scws_error.CKR_TOKEN_NOT_PRESENT';
  public CKR_TOKEN_NOT_RECOGNIZED = 'error.scws_error.CKR_TOKEN_NOT_RECOGNIZED';
  public CKR_TOKEN_WRITE_PROTECTED = 'error.scws_error.CKR_TOKEN_WRITE_PROTECTED';
  public CKR_USER_ALREADY_LOGGED_IN = 'error.scws_error.CKR_USER_ALREADY_LOGGED_IN';
  public CKR_USER_ANOTHER_ALREADY_LOGGED_IN = 'error.scws_error.CKR_USER_ANOTHER_ALREADY_LOGGED_IN';
  public CKR_USER_NOT_LOGGED_IN = 'error.scws_error.CKR_USER_NOT_LOGGED_IN';
  public CKR_USER_PIN_NOT_INITIALIZED = 'error.scws_error.CKR_USER_PIN_NOT_INITIALIZED';
  public CKR_USER_TOO_MANY_TYPES = 'error.scws_error.CKR_USER_TOO_MANY_TYPES';
  public CKR_USER_TYPE_INVALID = 'error.scws_error.CKR_USER_TYPE_INVALID';
  public CXR_NO_LICENSE_KEY = 'error.scws_error.CXR_NO_LICENSE_KEY';
  public MWR_IMPORT_FILE_INVALID = 'error.scws_error.MWR_IMPORT_FILE_INVALID';
  public MWR_IMPORT_KEY_LENGTH_UNSUPPORTED = 'error.scws_error.MWR_IMPORT_KEY_LENGTH_UNSUPPORTED';
  public MWR_IMPORT_PASSWORD_INVALID = 'error.scws_error.MWR_IMPORT_PASSWORD_INVALID';
  public MWR_PUK_ALREADY_USED = 'error.scws_error.MWR_PUK_ALREADY_USED';
  public MWR_SCWS_BAD_PARAMS = 'error.scws_error.MWR_SCWS_BAD_PARAMS';
  public MWR_SCWS_COMM_ERROR = 'error.scws_error.MWR_SCWS_COMM_ERROR';
  public MWR_SCWS_COMM_TIMEOUT = 'error.scws_error.MWR_SCWS_COMM_TIMEOUT';
  public MWR_SCWS_UNKNOWN_ERROR = 'error.scws_error.MWR_SCWS_UNKNOWN_ERROR';
  public MWR_SCWS_UNREACHABLE = 'error.scws_error.MWR_SCWS_UNREACHABLE';
  public WMR_IMPORT_KEY_TYPE_UNSUPPORTED = 'error.scws_error.WMR_IMPORT_KEY_TYPE_UNSUPPORTED';
  public ERROR_FILE_REQUIRED = 'error.error_file_required';

  constructor() {
  }
}
